import React, { useEffect, useState } from 'react';
import { TextField, Select, MenuItem, FormControl, InputLabel, Button, Container, Grid, Typography, CircularProgress } from '@mui/material';
import apiInstance from '../../../../services/ServiceApi';
import AlertModal from '../../../../components/utilities/AlertModal';
const AlfinVenta = () => {
  const [agencias, setAgencias] = useState([]);
  const [dniError, setDniError] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const [modalMessage, setModalMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const grupos = ['G1','G2','G3','G4','G5','G6','G7','G8','G9']
    const [formData, setFormData] = useState({
        ejecutivoId: '',
        identificador: '',
        nombreCliente: '',
        grupoRiesgo: '',
        montoSolicitado: '',
        nombreAgencia:'',
        celular: '',
        agenciaAtencion: '',
        fechaVisita: '',
        horaVisita: ''
     });
 
   
     useEffect(() => {
      // Función para cargar las agencias desde la API
      const cargarAgencias = async () => {
        try {
          const response = await apiInstance.get('/agenciaAlfin/');
          setAgencias(response.data); // Actualiza el estado con las agencias recibidas
        } catch (error) {
          // Maneja el error aquí, por ejemplo, mostrando un mensaje
          console.error('Error al obtener las agencias:', error);
        }
      };
  
      // Llama a la función cargarAgencias
      cargarAgencias();
    }, []);
  const handleKeyPress = (e) => {
    // Permitir solo la entrada de números
    if (e.key < '0' || e.key > '9') {
      e.preventDefault();
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'agenciaAtencion') {
      const agenciaSeleccionada = agencias.find(agencia => agencia.id === value);
      const codigoEjecutivo = agenciaSeleccionada ? agenciaSeleccionada.codigo.trim() : '';
      const nombreAgencia = agenciaSeleccionada ? agenciaSeleccionada.data1.trim() : '';
      
      setFormData({
        ...formData,
        [name]: value, // Aquí almacenas el 'id' de la agencia seleccionada
        ejecutivoId: codigoEjecutivo ,// Aquí almacenas el código ejecutivo correspondiente
        nombreAgencia: nombreAgencia // Aquí almacenas el código ejecutivo correspondiente
      });
    } 
    else {
      setFormData({ ...formData, [name]: value });
    }
  };
  
  const handleDniChange = (e) => {
    const { value } = e.target;
    if (value.length === 8) {
      setDniError(''); // Si tiene 8 dígitos, no hay error
    } else {
      setDniError('El DNI debe tener 8 dígitos.'); // Si no tiene 8 dígitos, muestra el mensaje de error
    }
    // Llama a handleInputChange solo si el valor es menor o igual a 8 dígitos
    if (value.length <= 8) {
      handleInputChange(e);
    }
  };
  const handleKeyDown = (e) => {
    // Bloquear la entrada de 'e', '+', '-', etc.
    if (e.key === 'e' || e.key === '+' || e.key === '-') {
      e.preventDefault();
    }
  };
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault(); // Si lo pegado no es un número, previene la acción
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const userData = JSON.parse(localStorage.getItem('user'));
    const username = userData ? userData.username : null;

    const requestBody = {
      ...formData,
      cuenta: formData.identificador, // Campo cuenta igual al DNI
      tipificacion: { venta: "venta" }, // Campo tipificacion como objeto JSON
      id_linea_negocio: 2, // Campo id_linea_negocio estático
      codigo_llamada: 2, // Campo codigo_llamada estático
      codigo_usuario: username // Campo codigo_usuario del localStorage
    };

    apiInstance.post('/saveGestion/', requestBody)
      .then(response => {
        setModalMessage('Tu formulario ha sido enviado con éxito.'); // Puedes personalizar este mensaje
        setModalOpen(true); // Abre el modal
        setAlertType('success')
        setFormData({
          ejecutivoId: '',
          identificador: '',
          nombreCliente: '',
          grupoRiesgo: '',
          montoSolicitado: '',
          celular: '',
          agenciaAtencion: '',
          nombreAgencia:'',
          fechaVisita: '',
          horaVisita: ''
        });
      })
      .catch(error => {
        setModalMessage(error);
        setAlertType('warning')

      })
      .finally(() => {
        setIsLoading(false); 
      });;
  };

  return (
    <Container maxWidth="sm">
       <AlertModal
                open={modalOpen} 
                onClose={()=>setModalOpen(false)} 
                message={modalMessage} 
                alertType={alertType}
            />
      <Typography variant="h4" component="h1" gutterBottom>
        CANAL CAMPO QUBUS
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {false && (
            <Grid item xs={12}>
                <TextField
                name="ejecutivoId"
                disabled={true}
                label="CODIGO DE EJECUTIVO (ID)"
                value={formData.ejecutivoId}
                onChange={handleInputChange}
                margin="normal"
                fullWidth
                />
            </Grid>)}
            <Grid item xs={12}>
                <TextField
                error={dniError.length > 0} // Esto activará el estado de error en el TextField
                helperText={dniError} 
                name="identificador"
                label="DNI cliente:"
                type='number'
                value={formData.identificador}
                onChange={handleDniChange}
                onKeyPress={handleKeyPress}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste} 
                margin="normal"
                fullWidth
                required
                inputProps={{
                  maxLength: 8
                }}
                />
            </Grid>
            <Grid item xs={12}>

                <TextField
                name="nombreCliente"
                label="Nombre"
                value={formData.nombreCliente}
                onChange={handleInputChange}
                margin="normal"
                required
                fullWidth
                />
            </Grid>
            <Grid item xs={12}>

                <FormControl fullWidth margin="normal">
                  <InputLabel id="grupo-agencia">Grupo Riesgo</InputLabel>
                    <Select
                      labelId="grupo-agencia"
                      name="grupoRiesgo"
                      value={formData.grupoRiesgo}
                      label="Grupo Riesgo"
                      required
                      onChange={handleInputChange}
                    >
                      {grupos.map((g) => (
                        <MenuItem key={g} value={g}>
                          {g}
                        </MenuItem>
                      ))}
                    </Select>
                </FormControl>
               
            </Grid>
            <Grid item xs={12}>
                <TextField
                name="montoSolicitado"
                label="Monto Solicitado:"
                type='number'
                value={formData.montoSolicitado}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste} 
                margin="normal"
                fullWidth
                required
                inputProps={{ step: "0.01", max: 100000 }} // Se establece el valor máximo
                error={formData.montoSolicitado > 100000} // Muestra un error si supera 100,000
                helperText={formData.montoSolicitado > 100000 ? 'El monto máximo es 100,000.' : ''}
                />
            </Grid>
            <Grid item xs={12}>
              <TextField
              name="celular"
              label="Celular:"
              type="number"
              value={formData.celular}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              onKeyDown={handleKeyDown}
              onPaste={handlePaste} 
              required
              margin="normal"
              fullWidth
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              />
          </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="agencia-atencion-label">Agencia de Atención</InputLabel>
                  <Select
                    labelId="agencia-atencion-label"
                    name="agenciaAtencion"
                    value={formData.agenciaAtencion}
                    label="Agencia de Atención"
                    onChange={handleInputChange}
                    required

                  >
                    {agencias.map((agencia) => (
                      <MenuItem key={agencia.id} value={agencia.id}>
                        {agencia.data1} 
                      </MenuItem>
                    ))}
                  </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                name="fechaVisita"
                label="Fecha de Visita a Agencia:"
                type="date"
                value={formData.fechaVisita}
                onChange={handleInputChange}
                margin="normal"
                fullWidth
                required

                InputLabelProps={{ shrink: true }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="horaVisita"
                label="Hora de Visita Agencia:"
                type="time"
                value={formData.horaVisita}
                onChange={handleInputChange}
                margin="normal"
                fullWidth
                required

                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
              />
          </Grid>


          <Grid container spacing={2} justifyContent="center">
          <Button
              variant="contained"
              type="submit"
              disabled={isLoading} // Deshabilita el botón cuando isLoading es true
              sx={{ mt: 3 }}
            >
              {isLoading ? <CircularProgress size={24} /> : 'Enviar Formulario'}
            </Button>
          </Grid>
        </Grid>

      </form>
    </Container>
  );
};

export default AlfinVenta;
